import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheComuniApi } from "../data/apis";
import { useMemo } from "react";


export function useRolesDataSource() {
    const api = new AnagraficheComuniApi(apiConfiguration);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getRoles();
          },
    
          byKey: (key) => {
            return api.getRoleById({
                roleId: key
            });
          },
        });
      }, []);
    
      return dataSource;
}


